import { Admin, ListGuesser, Resource, Layout } from "react-admin";
import { useMemo } from "react";
import {
  Switch,
  Route,
  Redirect,
  useParams,
  useHistory,
} from "react-router-dom";
import authProvider from "./raProviders/authProvider";
import dataProvider from "./raProviders/dataProvider";
import { i18nProvider } from "./raProviders/i18nProvider";
import LoginPage from "./pages/login";
import {
  TourPackageCreate,
  TourPackageEdit,
  TourPackageList,
} from "./components/tourPackages";
import BrandAppBar from "./components/BrandAppBar";
import { getThemeByBrand } from "./theme";
import { BRANDS } from "./config/brands";
import { useBrand } from "./context/BrandContext";

function AdminPanel() {
  const { brand } = useParams();
  const { selectedBrand, setSelectedBrand } = useBrand();
  const history = useHistory();
  const validBrand = BRANDS[brand] ? brand : selectedBrand || "ht";
  const myTheme = useMemo(() => getThemeByBrand(validBrand), [validBrand]);

  // Actualizar el brand seleccionado si viene de la URL
  if (brand && brand !== selectedBrand) {
    setSelectedBrand(brand);
  }

  return (
    <Admin
      key={validBrand}
      dataProvider={dataProvider(validBrand)}
      authProvider={authProvider(validBrand)}
      i18nProvider={i18nProvider}
      theme={myTheme}
      basename={`/${validBrand}`}
      // react-admin 3.x no tiene prop "appBar" en <Admin>: el AppBar
      // custom se inyecta vía el layout (Layout -> appBar)
      layout={(layoutProps) => (
        <Layout
          {...layoutProps}
          appBar={(appBarProps) => (
            <BrandAppBar
              {...appBarProps}
              brandKey={validBrand}
              brandName={BRANDS[validBrand].name}
              onBrandChange={(b) => {
                setSelectedBrand(b);
                history.push(`/${b}/`);
              }}
            />
          )}
        />
      )}
    >
      <Resource
        name="tour-packages"
        list={(props) => (
          <TourPackageList {...props} brandName={BRANDS[validBrand].name} />
        )}
        create={(props) => (
          <TourPackageCreate {...props} brandName={BRANDS[validBrand].name} />
        )}
        edit={(props) => (
          <TourPackageEdit {...props} brandName={BRANDS[validBrand].name} />
        )}
        options={{ label: "Paquetes" }}
      />
      <Resource
        name="customers"
        list={ListGuesser}
        options={{ label: "Clientes" }}
      />
      <Resource
        name="orders"
        list={ListGuesser}
        options={{ label: "Pedidos" }}
      />
      <Resource
        name="config"
        list={ListGuesser}
        options={{ label: "Configuración" }}
      />
    </Admin>
  );
}

function App() {
  const { selectedBrand } = useBrand();

  return (
    <Switch>
      {/* Ruta de login */}
      <Route path="/login" component={LoginPage} />

      {/* Ruta raíz - redirigir a login o al dashboard del brand seleccionado */}
      <Route path="/" exact>
        {selectedBrand && localStorage.getItem("admin-token") ? (
          <Redirect to={`/${selectedBrand}/`} />
        ) : (
          <Redirect to="/login" />
        )}
      </Route>

      {/* Ruta con brand - admin panel */}
      <Route path="/:brand" component={AdminPanel} />

      {/* Redirigir cualquier otra ruta inmediatamente a login */}
      <Route>
        <Redirect to="/login" />
      </Route>
    </Switch>
  );
}

export default App;
